import { multi, number, OTHER, option } from "../us-fields";

export const PROXIMAL_AORTA = number(
  "aorta.proximal_size",
  "Proximal aorta size",
  "cm",
);

export const MID_AORTA = number("aorta.mid_size", "Mid-aorta size", "cm");

export const DISTAL_AORTA = number(
  "aorta.distal_size",
  "Distal aorta size",
  "cm",
);

export const LONGITUDINAL_AORTA = number(
  "aorta.longitudinal_size",
  "Longitudinal aorta size",
  "cm",
);

export const MAXIMAL_AORTA = number(
  "aorta.max_size",
  "Maximal size of abdominal aorta",
  "cm",
);

export const AORTA_INTERPRETATION = multi(
  "aorta.interpretation",
  "Interpretation",
  [
    option("no_aaa", "No abdominal aortic aneurysm"),
    option("aaa", "Abdominal aortic aneurysm"),
    option("indeterminate", "Indeterminate"),
    OTHER,
  ],
);
